var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.42545C14.4484 1.65977 13.8481 1.82841 13.2298 1.89409C13.8717 1.51853 14.3525 0.925213 14.5818 0.225451C13.9794 0.578331 13.3195 0.825776 12.6313 0.956811C12.3437 0.654018 11.9958 0.4128 11.6094 0.248186C11.2229 0.0835725 10.8062 -0.000908491 10.3852 7.36757e-06C8.68165 7.36757e-06 7.31162 1.35977 7.31162 3.02841C7.31162 3.26273 7.34046 3.49705 7.38733 3.72249C4.83656 3.59113 2.56159 2.39113 1.04915 0.553853C0.77357 1.01737 0.629156 1.54514 0.630934 2.08225C0.630934 3.13314 1.17354 4.05977 2.00096 4.60474C1.51335 4.58583 1.03715 4.45385 0.611104 4.21953V4.25681C0.611104 5.72841 1.66747 6.94793 3.07535 7.22841C2.81101 7.29602 2.53907 7.33061 2.26595 7.33136C2.06586 7.33136 1.87658 7.31184 1.68549 7.28521C2.07487 8.48521 3.20875 9.35681 4.55895 9.38521C3.50258 10.2 2.17943 10.6793 0.742699 10.6793C0.484918 10.6793 0.246966 10.6704 0 10.642C1.36282 11.503 2.97981 12 4.72119 12C10.3744 12 13.4677 7.38817 13.4677 3.38521C13.4677 3.25385 13.4677 3.12249 13.4587 2.99113C14.0572 2.55977 14.5818 2.02545 15 1.42545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsTwitter);
export default __webpack_public_path__ + "static/media/contactUsTwitter.4271fcaa2fd76458e83bab0b98d98797.svg";
export { ForwardRef as ReactComponent };